import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import { FormButton } from "reusableComponents";

const CalendarSync = () => {
  const { t } = useTranslation("global");
  const navigate = useNavigate();

  return (
    <section className={styles.calendarSync}>
      <div className={styles.header}>
        <h2 className={styles.calendarTitle}>{t("calendar.sync.title")}</h2>
        <div dangerouslySetInnerHTML={{ __html: t("calendar.sync.text") }} />
      </div>
      <div className={styles.syncTypes}>
        <div className={styles.syncType}>
          <div className={styles.panel}>
            <div className={styles.panelHeading}>
              {t("calendar.sync.googleCalendar")}
            </div>
            <div className={styles.panelBody}>
              <p
                dangerouslySetInnerHTML={{
                  __html: t("calendar.sync.googleDescription"),
                }}
              />
               <FormButton
            label={t("calendar.sync.configureSync")}
            onClick={() => {navigate("/calendar/syncgoogle")}}
            variant="primary"
          />
            
            </div>
          </div>
        </div>
        <div className={styles.syncType}>
          <div className={styles.panel}>
            <div className={styles.panelHeading}>
              {t("calendar.sync.microsoftOutlook")}
            </div>
            <div className={styles.panelBody}>
              <p
                dangerouslySetInnerHTML={{
                  __html: t("calendar.sync.microsoftDescription"),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CalendarSync;
